import { AgentWidgetConfig } from "../../apis/agent.api";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar";
import { cn } from "../../lib/utils";
import defaultAgentIcon from "../public/icons/agent.webp?url";

const AgentAvatar = ({
  config,
  className,
}: {
  config?: AgentWidgetConfig;
  className?: string;
}) => {
  const initial = config?.ai_agent.agent_name.charAt(0).toUpperCase();

  const iconSrc =
    config?.agent_icon ?? (defaultAgentIcon?.src || defaultAgentIcon);

  return (
    <Avatar className={cn("size-[46px]", className)}>
      <AvatarImage className="object-cover" src={`${iconSrc}`} />
      <AvatarFallback className="text-black">{initial}</AvatarFallback>
    </Avatar>
  );
};

export default AgentAvatar;
